import BaseModal from "@components/BaseModal";
import PropTypes from "prop-types";
import {useEffect, useState} from "react";
import {ErrorBoundary, useErrorBoundary} from "react-error-boundary";
import {useTranslation} from "react-i18next";
import {PrimaryButton} from "@/components/Button";
import {useLogo} from "../../../util/logoUtils";
import {isChunkLoadError, reloadOnceForChunkError} from "../../../util/chunkLoadError";
import styles from "../ErrorBoundaryHandler.module.css";

const goHomeWithReload = () => {
  window.location.href = "/";
};

const FallbackComponentRedirect = () => {
  const {resetBoundary} = useErrorBoundary();
  const [countdown, setCountdown] = useState(5);
  const {t} = useTranslation();
  const logoImg = useLogo(); // Dynamic logo based on hostname

  const handleErrorState = () => {
    goHomeWithReload();
    resetBoundary();
  };

  useEffect(() => {
    const timer = setTimeout(goHomeWithReload, 5000);

    const countdownTimer = setInterval(() => {
      setCountdown(c => (c > 0 ? c - 1 : 0));
    }, 1000);

    return () => {
      clearTimeout(timer);
      clearInterval(countdownTimer);
    };
  }, []);

  return (
    <BaseModal
      open={true}
      footer={null}
      closable={false}
      centered
      width={555}
      styles={{
        body: {
          padding: window.innerWidth <= 768 ? "32px 0px 24px 0px" : "32px 32px 24px 32px",
          borderRadius: 16,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        },
      }}
    >
      <div className={styles.error_boundary_container}>
        <img
          src={logoImg}
          alt="Logo"
          className={styles.errorBoundaryLogoImg}
        />
        <p className={styles.error_boundary_title}>{t("errorBoundaryRedirect1")}</p>
        <p
          className={styles.error_boundary_action}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
          }}
        >
          <span style={{fontSize: 16, textAlign: "center"}}>
            {t("errorBoundaryRedirect2")} <span style={{fontWeight: 600}}>({countdown})</span>
          </span>
        </p>
        <PrimaryButton
          onClick={handleErrorState}
          style={{marginTop: 30}}
        >
          {t("errorBoundaryBtnHome")}
        </PrimaryButton>
      </div>
    </BaseModal>
  );
};

export const ErrorBoundaryRedirect = ({children}) => {
  return (
    <ErrorBoundary
      FallbackComponent={FallbackComponentRedirect}
      onError={error => {
        if (isChunkLoadError(error)) {
          reloadOnceForChunkError();
        }
      }}
    >
      {children}
    </ErrorBoundary>
  );
};

ErrorBoundaryRedirect.propTypes = {
  children: PropTypes.node,
};
